var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-upload-container"},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.uploadApi,"headers":_vm.headers,"name":"file","show-file-list":false,"before-upload":_vm.beforeUpload,"on-success":_vm.handleSuccess}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }